import React from 'react';
import { Navigate } from 'react-router-dom';
import {getToken,getLoginData} from 'hooks/storage';
const Private = ({ children }) => {
    const auth = (getToken())?true:false; 
    const loginData = (getLoginData())?true:false; 

    return auth && loginData ? children : <Navigate to="/login" />;
}

export default Private;